/*External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { ListDevicesActions, ListDevicesActionTypes } from './action';

type resultType = {
  total: number;
  devices: Array<object>;
};

export interface listDevicesState {
  onChangeValue: string;
  isListDevicesLoading: boolean;
  result: resultType;
  error: string;
}

export const initialListDevicesState: listDevicesState = {
  onChangeValue: '',
  isListDevicesLoading: false,
  result: {
    total: 0,
    devices: [],
  },
  error: '',
};

export function listDevicesReducer(state = initialListDevicesState, action: ListDevicesActions) {
  switch (action.type) {
    case ListDevicesActionTypes.ON_CHANGE_INPUT:
      return update(state, {
        onChangeValue: { $set: action.value },
      });
    case ListDevicesActionTypes.LIST_DEVICES_REQUEST:
      return update(state, {
        isListDevicesLoading: { $set: true },
      });
    case ListDevicesActionTypes.LIST_DEVICES_SUCCEEDED:
      return update(state, {
        result: {
          total: { $set: action.result.total },
          devices: { $set: action.result.devices },
        },
        isListDevicesLoading: { $set: false },
      });
    case ListDevicesActionTypes.LIST_DEVICES_FAILED:
      return update(state, {
        error: { $set: action.error },
      });
    case ListDevicesActionTypes.CLOSE_SEARCH_MODAL:
      return update(state, {
        result: {
          devices: { $set: [] },
          total: { $set: 0 },
        },
        onChangeValue: { $set: '' },
      });
    default:
      return state;
  }
}
